import router from '@/router';

const GTM_ID = 'GTM-PR8MKN9Z';

const googleTagManager = {
  install(app, options = {}) {
    const {
      defer = false,
      enabled = true,
      debug = false,
      vueRouter = router,
    } = options;

    if (!enabled) return;

    // Inject GTM script into head
    const script = document.createElement('script');
    if (defer) script.defer = true;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');`;
    document.head.appendChild(script);

    // Inject GTM noscript iframe into body - required for browsers without JavaScript enabled
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);

    // Debug mode
    if (debug) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'gtm.debug', debug: true });
    }

    // Vue Router integration
    if (vueRouter) {
      vueRouter.afterEach((to) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'pageview',
          page: to.fullPath,
        });
      });
    }
  },
};

export default googleTagManager;
